<template>
  <div class="activity-box">
    <div class="title">
      <img :src="require('@/assets/images/activity_title.png')" />
    </div>
    <div class="bd">
      <img class="bg" :src="require('@/assets/images/activity_img.png')" />
      <img class="btn" @click="getSubject" :src="require('@/assets/images/activity_btn.gif')" />
    </div>
    <div class="ft">
      <div class="item">须知：</div>
      <div class="item">1.未购买过《科学实验》的微信号可领取。</div>
      <div class="item">2.领取后请关注公众号【明明城堡】。</div>
      <div class="item">3.明明城堡保留最终解释权。</div>
    </div>
  </div>
</template>

<script>
import { getFreeSubject } from './query.gql'

export default {
  name: 'activity',
  data() {
    return {}
  },
  components: {
  },
  async mounted() {
    console.log('新年活动页')
    await this.weixinAuth()
  },
  methods: {
    getSubject() {
      const self = this

      self.$toast({
        type: 'loading',
        mask: true,
        duration: 0,
        message: '领取中'
      })

      self.$apollo.mutate({
        mutation: getFreeSubject,
        variables: { subjectType: 'science' }
      }).then(res => {
        console.log(res.data.getFreeSubject)
        self.$toast.clear()
        if (res.data.getFreeSubject.freeSubjectId) {
          self.$router.push({
            name: 'activityGuide',
            query: { id: res.data.getFreeSubject.freeSubjectId }
          })
        } else {
          self.$toast.fail(res.data.getFreeSubject.error || '领取失败')
        }
      }).catch(err => {
        console.error('page: activity/index。请求getFreeSubject报错', err)
        self.$toast.clear()
        self.$toast.fail(err.graphQLErrors[0].message || '领取失败')
      })
    }
  }
}
</script>

<style lang="scss">
html,body,#app {
  height: 100%;
}
.activity-box {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 30px;
  padding-bottom: 130px;
  background-image: url('~@/assets/images/activity_bg.png');
  background-size: cover;

  .title {
    width: 80%;
    margin: 0 auto;

    img {
      width: 100%;
    }
  }

  .bd {
    position: relative;
    width: 80%;
    margin: 0 auto;
    margin-top: 10px;

    .bg {
      width: 100%;
    }

    .btn {
      width: 100%;
      position: absolute;
      bottom: 0px;
    }
  }

  .ft {
    width: 80%;
    margin: 0 auto;
    margin-top: 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: rgba(255,255,255,1);
  }
}
</style>
